var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-sheet', [_c('v-sheet', {
    staticClass: "mx-auto pa-60 pa-lg-120",
    attrs: {
      "id": "print-target",
      "width": "1080",
      "max-width": "100%"
    }
  }, [_c('resume-personal-information', {
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-name', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-education', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-work-experience', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-hash-tags', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-languages', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-office-skills', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-certifications', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), _c('resume-cover-letter', {
    staticClass: "mt-30 mt-lg-60",
    attrs: {
      "value": _vm.value.resume,
      "mode": "view"
    }
  }), !!_vm.value.questions.length ? [_c('v-sheet', {
    staticClass: "mt-30 mt-lg-60"
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v(" 추가질문답변 ")]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _vm._l(_vm.value.questions, function (item, index) {
    return _c('question-item', _vm._b({
      key: item.question._id,
      staticClass: "mt-10 mt-lg-20",
      attrs: {
        "readonly": ""
      }
    }, 'question-item', {
      value: item,
      index
    }, false));
  })], 2)] : _vm._e()], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }